import { z } from 'zod';

export const maxLength = 100;

const unrecognizedSchema = z.object({
  reason: z
    .string()
    .max(maxLength, `limite máxio de ${maxLength} ultrapassado`)
    .default(''),
});

export { unrecognizedSchema };
